export function strEnum(o) {
    return o.reduce((res, key) => {
        res[key] = key;
        return res;
    }, Object.create(null));
}
export class MapWithArray {
    constructor() {
        this.elements = [];
        this.elementsByKey = new Map();
    }
    getArray() {
        return this.elements.slice();
    }
    getElementCount() {
        return this.elements.length;
    }
    addElement(key, value) {
        if (this.elementsByKey.has(key)) {
            return false;
        }
        this.elementsByKey.set(key, value);
        this.elements.push(value);
        return true;
    }
    getElementByKey(key) {
        return this.elementsByKey.get(key);
    }
    removeElementByKey(key) {
        if (!this.elementsByKey.has(key)) {
            return false;
        }
        this.elements.splice(this.elements.indexOf(this.elementsByKey.get(key)), 1);
        this.elementsByKey.delete(key);
        return true;
    }
    clear() {
        this.elements = [];
        this.elementsByKey.clear();
    }
}
export function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            if (name !== 'constructor') {
                derivedCtor.prototype[name] = baseCtor.prototype[name];
            }
        });
        const baseDescriptors = Object.getOwnPropertyNames(baseCtor).reduce((propsToAssign, propName) => {
            const propDesc = Object.getOwnPropertyDescriptor(baseCtor, propName);
            if (propDesc.configurable && propDesc.writable) {
                propsToAssign[propName] = Object.getOwnPropertyDescriptor(baseCtor, propName);
            }
            return propsToAssign;
        }, {});
        Object.defineProperties(derivedCtor, baseDescriptors);
    });
}
export function extendClass(targetClass, superclass) {
    const propertyNames = Object.getOwnPropertyNames(superclass.prototype);
    propertyNames.forEach((propName) => {
        if (!targetClass.prototype[propName]) {
            Object.defineProperty(targetClass.prototype, propName, Object.getOwnPropertyDescriptor(superclass.prototype, propName));
        }
    });
}
//# sourceMappingURL=typed.js.map